import { render, staticRenderFns } from "./TrackingApp.vue?vue&type=template&id=bc38586e"
import script from "./TrackingApp.vue?vue&type=script&lang=js"
export * from "./TrackingApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports